<template>
	<footer class="gs-footer" role="contentinfo">
		<div class="container">

			
			<div class="footer-banner">
				
				
				<div class="banner-inner">
					<div class="banner-title">
						<h4>Contacta con nosotros</h4>
						<p class="banner-sub">Rellena el formulario y nos pondremos en contacto contigo lo antes posible.</p>
                        <img src="/images/footer/avionrojorayas.webp" alt="decor" class="banner-decor" />
					</div>

					<div class="banner-form">
						<form @submit.prevent="submitContact" novalidate>
							<div class="form-row">
								<input id="nombre" type="text" v-model="form.nombre" placeholder="Nombre" required />
							</div>
							<div class="form-row">
								<input id="email" type="email" v-model="form.email" placeholder="Correo electrónico" required />
							</div>
							<div class="form-row">
								<input id="telefono" type="tel" v-model="form.telefono" placeholder="Teléfono" />
							</div>
							<div class="form-row">
								<textarea id="mensaje" v-model="form.mensaje" placeholder="Mensaje" rows="4" required></textarea>
							</div>

							<div class="form-row form-actions">
								<button type="submit" class="btn-submit">Enviar mensaje</button>
								<p v-if="formSent" class="form-sent">Gracias — tu mensaje ha sido enviado.</p>
							</div>
						</form>
					</div>
				</div>
			</div>

			<!-- Sección de enlaces abajo -->
			<div class="footer-links-grid">

				<div class="fila">
					<div class="brand-area">
						<img src="/images/header/grupostudiologo.png" alt="GrupoStudio logo" class="footer-logo" />
						<a class="address" href="https://www.google.com/maps/place/Grupo+Studio+Formaci%C3%B3n/@39.478162,-0.3497134,17z/data=!3m1!4b1!4m6!3m5!1s0xd60489b27387515:0x856ed8afa26ad2dd!8m2!3d39.4781579!4d-0.3471385!16s%2Fg%2F1tfrytk7?entry=ttu" target="_blank">

							<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-map-marker-alt"></i></span>
							<span class="elementor-icon-list-text">C/ Albalat dels Tarongers, 32 Bajo Izq - 46021 Valencia</span>
						</a>

						<div class="phones">
							
							<a href="tel:963624193" target="_blank">

								<span class="elementor-icon-list-icon">
									<i class="fas fa-phone" aria-hidden="true"></i>
								</span>
								<span class="elementor-icon-list-text">963 624 193</span>
							</a>

							<a href="http://wa.me/+34626252361" target="_blank">

								<span class="elementor-icon-list-icon">
									<i aria-hidden="true" class="fab fa-whatsapp"></i>						
								</span>
								<span class="elementor-icon-list-text">626 252 361</span>
							</a>
							
						</div>

						<a class="email" href="mailto:info@grupostudio.es" target="_blank">

							<span class="elementor-icon-list-icon">
								<i aria-hidden="true" class="far fa-envelope"></i>						
							</span>
							<span class="elementor-icon-list-text">info@grupostudio.es</span>
						</a>
					</div>

					<div class="links-pair">
						<div class="social">
							<h4>Social</h4>
							<ul>
								<li class="elementor-icon-list-item">
									<a href="https://www.instagram.com/grupostudioformacion/" target="_blank">

										<span class="elementor-icon-list-icon">
											<i aria-hidden="true" class="fab fa-instagram"></i>						
										</span>
										<span class="elementor-icon-list-text">Instagram</span>
									</a>
								</li>
								<li class="elementor-icon-list-item">
									<a href="https://www.facebook.com/grupostudiovalencia" target="_blank">

										<span class="elementor-icon-list-icon">
											<i aria-hidden="true" class="fab fa-facebook-f"></i>						
										</span>
										<span class="elementor-icon-list-text">Facebook</span>
									</a>
								</li>
								<li class="elementor-icon-list-item">
									<a href="https://es.linkedin.com/company/grupo-studio-formaci%C3%B3n" target="_blank">

										<span class="elementor-icon-list-icon">
											<i aria-hidden="true" class="fab fa-linkedin-in"></i>						
										</span>
										<span class="elementor-icon-list-text">LinkedIn</span>
									</a>
								</li>
							</ul>
						</div>

						<div class="legal">
							<h4>Legal</h4>
							<ul>
								<li><router-link to="/aviso-legal">Aviso legal</router-link></li>
								<li><router-link to="/politica-privacidad">Política de privacidad</router-link></li>
								<li><router-link to="/politica-cookies">Política de cookies</router-link></li>
								<li><a href="/transparencia.pdf" target="_blank">Transparencia</a></li>
							<li><a href="/CARTEL-CASTELLANO-ECOVUL-2024.pdf" target="_blank">ECOVUL</a></li>
							</ul>
						</div>
					</div>
				</div>
				
				<div class="footer-bottom">
					<p class="copyright">© <span>{{ year }}</span> GrupoStudio.</p>
				</div>

			</div>
			
		</div>
	</footer>
</template>

<script>
import { db } from "@/db/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default {
  name: "SiteFooter",
  data() {
    return {
      year: new Date().getFullYear(),
      form: { nombre: "", email: "", telefono: "", mensaje: "" },
      formSent: false,
      formErrors: {}
    };
  },
  methods: {
    async submitContact() {
      this.formErrors = {};

      if (!this.form.nombre || !this.form.nombre.trim()) this.formErrors.nombre = "Nombre es obligatorio";
      if (!this.form.email || !this.form.email.trim()) this.formErrors.email = "Email es obligatorio";
      else if (!/^\S+@\S+\.\S+$/.test(this.form.email)) this.formErrors.email = "Email no válido";
      if (!this.form.mensaje || !this.form.mensaje.trim()) this.formErrors.mensaje = "Escribe un mensaje";

      if (Object.keys(this.formErrors).length) return;

      if (!db) {
        alert("Firebase no está configurado. Por favor, configura las variables de entorno.");
        return;
      }

      try {
      
        await addDoc(collection(db, "contacto"), {
          nombre: this.form.nombre,
          email: this.form.email,
          telefono: this.form.telefono,
          mensaje: this.form.mensaje,
          createdAt: serverTimestamp(),
          emailEnviado: false // Flag para controlar el envío de emails
        });

        this.formSent = true;

       
        setTimeout(() => {
          this.form = { nombre: "", email: "", telefono: "", mensaje: "" };
          this.formSent = false;
        }, 2000);
      } catch (error) {
        console.error("Error al enviar el formulario: ", error);
        alert("Error al enviar el formulario. Por favor, inténtalo de nuevo.");
      }
    }
  }
};
</script>


<style lang="scss" scoped>
$gs-red: #E20000;
$text: #333333;
$muted: #777777;
$banner-bg: #F8F8F8;

:root{ --gs-red: #e20000 }

.gs-footer{
	background: transparent !important;
	color: $text;
	font-family: Montserrat, system-ui, -apple-system, 'Segoe UI', Roboto, Arial;
    width: 100%;
    z-index: 2000;
}

.container{ width: 100%; margin:0 auto; display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column; }


.footer-banner{ 
	background: linear-gradient(90deg, #ffffff 0%, rgb(255, 232, 232) 100%); 
	box-shadow: 0 2px 10px rgba(0,0,0,0.1); 
	padding: 78px 40px; 
	border-radius:20px; 
	width: 70%; 
    position: relative;     
    z-index: 1;            
    margin-bottom: -60px;
    
}
.banner-inner{ 
	display:flex;
    flex-direction: row; 
    justify-content: space-between;
    align-items: center;
    height: 250px;
    margin-right: 80px;
    margin-left: 40px;
}
.banner-title{ 
	width:50%; 
	height: 100%; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 35px;
}

.banner-form{
	width: 40%;
	position: relative;
	z-index: 3; /* ensure the form itself sits above the links grid when overlapping */
}
.banner-decor{ 
	width: 130px; 
}
.banner-title h4{ 
	color: #e20000; 
	font-size:32px;
    margin: 0;
}
.banner-title .banner-sub{ 
	font-size:19px; 
	max-width:370px; 
	line-height:1.4; 
    margin: 0;
}

.banner-form form{ 
	display:flex; 
	flex-direction:column; 
	align-items:center;
	gap:12px; 
}
.banner-form input,
.banner-form textarea{ 
	width: 370px; 
	padding:14px 22px; 
	font-family: 'montserrat'; 
	box-shadow: 3px 3px 5px rgba(0,0,0,0.1); 
	border: none; 
	border-radius:20px; 
	font-size:14px; 
	color:$text; 
	background:#fff 
}
.banner-form textarea{ 
	height: 60px; 
	resize: none; 
}
.banner-form input:focus,
.banner-form textarea:focus{ 
	outline:2px solid rgba($gs-red, 0.12); 
	border-color:$gs-red }
.form-actions{ 
	display:flex; 
	align-items:center; 
	gap:12px 
}
.btn-submit{ 
	background:$gs-red; 
	color:#fff; 
	border:none; 
	padding: 14px 14px; 
	border-radius:25px; 
	cursor:pointer; 
	font-family: 'Montserrat'; 
	font-weight:700;
	margin-top:10px;
	font-size: 16px;
}
.btn-submit:hover{ 
	background: darken($gs-red, 6%) 
}
.form-sent{ 
	color:green; 
	font-size:13px; 
	margin:0 
}


.footer-links-grid{ 
	
	display: flex;
    background-color: white;
	flex-direction: column;
	justify-content: center;
	gap: 60px; 
	align-items: center;
	width: 100%;
	padding: 79px 0px 0px 0px; 
	min-height: 320px;
	border: 1px solid #cccccc;
	box-shadow: 0 2px 10px rgba(0,0,0,0.1);
	border-top-left-radius: 60px;
	border-top-right-radius: 60px;
	position: relative;
	z-index: 0;
}

.fila{ 
	display:flex; 
	flex-direction: row; 
	align-items: center;
	justify-content: space-between; 
	width: 100%; 
	max-width: 1100px;
	padding: 30px 24px 30px 24px;
}

.brand-area, .social, .legal{ 
	display:flex; 
	flex-direction:column; 
	align-items:start; 
	gap: 18px; 
    margin-top: 50px;
}
.social ul, .legal ul{
	display:flex; 
	flex-direction:column; 
	align-items:start; 
	gap: 18px;
}


.links-pair { 
	display: flex; 
	flex-direction: row;
	gap: 82px; 
	align-items: flex-start 
}


.footer-logo{ 
	width:190px; 
	height:auto; 
	display:block; 
	margin-bottom:12px 
}
.address{ 
	margin:6px 0 12px 0; 
	font-size:19px; 
	line-height:1.4; 
	text-decoration:none;
	color: rgb(30, 30, 30);

	i{
		margin-right: 6px; 
		color: $gs-red; 
		font-size: 16px; 
		width: 18px; 
		text-align: center; 
	}
}
.phones a{ 
	text-decoration:none; 
	margin-right:8px ;
	font-size:19px; 
}
.phones{ 
	gap: 8px; 
	display: flex; 
}
.email{ 
	display:inline-block; 
	text-decoration:none; 
	margin-top:10px; 
	font-size:19px; 
}

.social h4, .legal h4{ 
	color: $muted; 
	margin:0 0 10px 0; 
	font-size:18px 
}
.social ul, .legal ul{ 
	list-style:none; 
	padding:0; 
	margin:0 
}
.social li, .legal li{ 
	margin-bottom:8px; 
	font-size: 18px; 
}

.social a, .legal a{ 
	text-decoration:none; 
	font-size:19px; 
	color:black; 
}
.social a:hover, .legal a:hover, .brand-area a:hover{ color:$gs-red }

.social a, .phones a, .email { 
	display: inline-flex; 
	align-items: center; 
	gap: 8px; 
	color: black }
.social a i, .phones a i, .email i { 
	margin-right: 6px; 
	color: $gs-red; 
	font-size: 16px; 
	width: 18px; 
	text-align: center; 
}
.email .email-text{ font-weight: normal }


.footer-bottom{ background-color: white; z-index: 3; width: 100%; border: 1px solid #cccccc; padding-top:25px; padding-bottom: 25px; display:flex; justify-content:center }
.copyright{ font-size:13px }

@media (max-width: 768px) {
    .gs-footer {
        padding-top: 50px;
		width: 100%;
		margin: 0 auto;
    }

   
    .footer-banner {
        width: 90%;
        padding: 40px 20px; 
        border-radius: 15px; 
        margin-bottom: -20px; 
    }

    .banner-inner {
        flex-direction: column; 
        height: auto; 
        margin: 0; 
        gap: 30px;
    }

    .banner-title {
        width: 100%; 
        text-align: center;
        gap: 10px;
    }

    .banner-title h4 {
        font-size: 28px; 
    }

    .banner-title .banner-sub {
        font-size: 16px;
        max-width: 90%;
    }

    .banner-decor {
        width: 100px; 
    }
    
    .banner-form {
        width: 100%; 
    }

    
    .banner-form input,
    .banner-form textarea {
        width: 100%; 
        max-width: 350px; 
        padding: 12px 18px;
        font-size: 14px;
        border-radius: 15px;
    }

    .form-row {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .btn-submit {
        padding: 12px 12px;
        font-size: 14px;
        border-radius: 15px;
        margin-top: 20px;
    }

    .footer-links-grid {
        flex-direction: column; 
        align-items: center;
        gap: 40px; 
        padding: 50px 0px 0px 0px; 
        border-top-left-radius: 30px; 
        border-top-right-radius: 30px; 
        min-height: auto;
		width: 100%;
    }

	.fila {
		padding: 0px 0px 0px 0px;
		flex-direction: column; 
		gap: 40px; 
		align-items: center; 
	}

    .brand-area, .social, .legal{ 
        width: 100%; 
        align-items: center; 
        margin-top: 0;
        text-align: center;
    }

    .footer-logo {
        width: 160px; 
        margin-bottom: 5px;
		margin-top: 50px;
		
    }

    .address, .phones a, .email {
        font-size: 16px; 
        line-height: 1.5;
    }

	.address {
		width: 60%;
	}

    .phones {
        flex-direction: column; 
        gap: 4px;
    }
    
    .phones a, .email {
        justify-content: center; 
    }

    .links-pair { 
        flex-direction: column; 
        gap: 30px; 
        width: 100%;
    }
    
    .social, .legal {
        align-items: center; 
        gap: 10px;
    }

    .social ul, .legal ul{ 
        align-items: center; 
    }
    
    .social li, .legal li, .social a, .legal a {
        font-size: 16px; 
    }
    
    .social a i, .phones a i, .email i { 
        font-size: 14px; 
    }
    
    
    .footer-bottom {
        padding: 15px 0 15px 0px ;
		width: 100%;
    }

    .copyright {
        font-size: 12px;
    }
}


</style>
